import { useState, useEffect } from "react";
import { makeStyles, Typography, Box } from "@material-ui/core";
import { useSelector } from "react-redux";

import { COLORS } from "../../../../../theme/colors";
import { ShaDowBox } from "../../../../../components/boxes";
import { NoDataCard } from "../../../../../components/parts";
import { CustomPieChart } from "../../../../../components/charts";
import { getData, onlyUniqueValuesInObject } from "../../../../../services";

const useStyles = makeStyles(() => ({
  box: {
    marginTop: 15,
    height: 300,
    backgroundColor: COLORS.darks[0][3],
  },
}));

export const PowerConsumptionUsagePayments = ({ buildingId, complexId, title }) => {
  const classes = useStyles();
  const [chartData, setChartData] = useState([]);
  const currencySymbol = useSelector((state) => state.auth.user.currency.symbol);

  let url = `/praas/v1/buildings/consumption-payments/`;

  if (buildingId) {
    url = `/praas/v2/buildings/${buildingId}/properties/consumption-payments/`;
  } else if (complexId) {
    url = `/praas/v2/complexes/${complexId}/properties/consumption-payments/`;
  }

  useEffect(() => {
    getData(url, (data) => {
      if (!onlyUniqueValuesInObject(data, 0)) {
        setChartData([
          {
            name: "Owner",
            value: data.owner,
            color: COLORS.purple,
            unit: currencySymbol,
          },
          {
            name: "PMC",
            value: data.pmc,
            color: "#DD87D2",
            unit: currencySymbol,
          },
          {
            name: "Tenants",
            value: data.tenant,
            color: "#F5DBF2",
            unit: currencySymbol,
          },
        ]);
      }
    });

    return () => setChartData([]);
  }, [complexId, buildingId]);

  if (!chartData.length) {
    return <NoDataCard title={title} type="pie" />;
  }

  return (
    <ShaDowBox fullHeight>
      <Box style={{ padding: 24 }}>
        <Typography variant="h4">{title}</Typography>
        <Box className={classes.box}>
          <CustomPieChart name="PowerConsumption" data={chartData} />
        </Box>
      </Box>
    </ShaDowBox>
  );
};
